var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 13.3359C25.9302 13.3359 25.3333 13.9329 25.3333 14.6693V16.0026C25.3333 21.1569 21.1543 25.3359 16 25.3359C10.8457 25.3359 6.66663 21.1569 6.66663 16.0026V14.6693C6.66663 13.9329 6.06969 13.336 5.33331 13.336C4.59694 13.336 4 13.9329 4 14.6693V16.0026C4 22.1789 8.66712 27.2651 14.6667 27.9285V29.3359H11.9999C11.2636 29.3359 10.6666 29.9329 10.6666 30.6693C10.6666 31.4056 11.2636 32.0026 11.9999 32.0026H19.9999C20.7363 32.0026 21.3333 31.4057 21.3333 30.6693C21.3333 29.9329 20.7363 29.336 19.9999 29.336H17.3333V27.9286C23.3328 27.2651 27.9999 22.1789 27.9999 16.0026V14.6693C27.9999 13.9329 27.403 13.3359 26.6666 13.3359Z",
    fill: "#EF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24C20.4177 24 24 20.4177 24 16V8C24 3.58231 20.4177 0 16 0C11.5823 0 8 3.58231 8 8V16C8 20.4177 11.5823 24 16 24ZM10.6667 8C10.6667 5.05506 13.0551 2.66669 16 2.66669C18.9449 2.66669 21.3333 5.05506 21.3333 8V16C21.3333 18.9449 18.9449 21.3333 16 21.3333C13.0551 21.3333 10.6667 18.9449 10.6667 16V8Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicRed);
export default __webpack_public_path__ + "static/media/MicRed.24bf12a58c49adda1685e4a98339acf7.svg";
export { ForwardRef as ReactComponent };